import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import quotes from '~/assets/images/sprite/quotes.svg'
import { Styles as QuizStyles } from '~/pages/anatomy/libs/singleChoiceStyles'
import { Styles as S } from '~/pages/anatomy/statement/styles'
import { Button } from '~/shared/components/Button'
import { SvgImage } from '~/shared/components/SvgImage'
import { OptionType } from '~/shared/constants/commonConstants'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTION_KEYS = [
  { key: 'yesMoreThanLike', i18nKey: 'first' },
  { key: 'sometimes', i18nKey: 'second' },
  { key: 'notReally', i18nKey: 'third' },
] as const

const MAJORITY_ANSWERS = new Set<string>(['yesMoreThanLike', 'sometimes'])

const StatementAnatomy = ({ pageId, nextPagePath }: TPageProps) => {
  const { t } = useTranslation('anatomy')
  const [answer, setAnswer] = useState('')

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Do you agree with this statement?',
  })

  let infoText: string | null = null
  if (answer) {
    infoText = MAJORITY_ANSWERS.has(answer)
      ? t('onboarding.statementAnatomy.majorityText')
      : t('onboarding.statementAnatomy.minorityText')
  }

  return (
    <S.LocalRoot>
      <S.LocalContainer>
        <div>
          <QuizStyles.Question>
            <Trans i18nKey="onboarding.quizSingleChoice.statementSocialMedia.title" />
          </QuizStyles.Question>

          <S.StatementContainer>
            <SvgImage svg={quotes} width={16} />

            <S.Statement>
              <Trans
                ns="anatomy"
                i18nKey="onboarding.statementAnatomy.statement"
              />
            </S.Statement>
          </S.StatementContainer>
        </div>

        <div>
          {OPTION_KEYS.map(({ key, i18nKey }, index) => (
            <QuizStyles.StyledOption
              key={key}
              $index={index}
              type={OptionType.RADIO}
              value={key}
              name="statementAnatomy"
              checked={answer === key}
              onChange={(optionValue) => {
                setAnswer(optionValue)
              }}
            >
              <QuizStyles.Value>
                {t(`onboarding.statementAnatomy.options.${i18nKey}`)}
              </QuizStyles.Value>
            </QuizStyles.StyledOption>
          ))}
        </div>
      </S.LocalContainer>

      <S.StickyBottom $hasAnswer={!!answer}>
        <S.StickyBottomInner>
          {infoText && <S.InfoText>{infoText}</S.InfoText>}
          <Button
            type="button"
            onClick={() => handleContinue(answer)}
            disabled={!answer}
          >
            <Trans i18nKey="actions.continue" />
          </Button>
        </S.StickyBottomInner>
      </S.StickyBottom>
    </S.LocalRoot>
  )
}

export default StatementAnatomy
